import { SUCCESS_COLOR, INFO_COLOR, ERROR_COLOR} from "@/stylus/snackbar_colors";
import { SUCCESS, INFO, ERROR} from "@/utils/snackbar_constants";

const colorReducer = (color) => {
  switch (color) {
    case SUCCESS:
      return SUCCESS_COLOR;
    case ERROR:
      return ERROR_COLOR;
    case INFO:
    default:
      return INFO_COLOR;
  }
};

const state = {
  content: "",
  color: "",
};

const mutations = {
  NOTIFY(state, value) {
    state.content = value.content;
    state.color = colorReducer(value.color);
  },
};

const getters = {
  getNotification: (state) => {
    return { content: state.content, color: state.color };
  },
};

const actions = {
  async notify({ commit }, box) {
    if (!box) return;
    const content = box.content;
    const color = box.color;
    const value = { content: content, color: color };
    commit("NOTIFY", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
